// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  treatyId: __t.u64().primaryKey().name("treaty_id"),
  worldId: __t.u64().name("world_id"),
  aId: __t.u64().name("a_id"),
  bId: __t.u64().name("b_id"),
  kind: __t.string(),
  status: __t.string(),
  goodwillAtForm: __t.u32().name("goodwill_at_form"),
  formedAt: __t.timestamp().name("formed_at"),
  renewedAt: __t.timestamp().name("renewed_at"),
  endedAt: __t.timestamp().name("ended_at"),
});
